"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSuggest = void 0;
var combobox_1 = require("./combobox");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var UserSuggest = (function (_super) {
    __extends(UserSuggest, _super);
    function UserSuggest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserSuggest.prototype.objectToSuggestion = function (user) {
        return {
            value: user.id.toString(),
            label: user.full_name,
            suggestionLabel: user.email ? "".concat(user.full_name, " (").concat(user.email, ")") : user.full_name,
        };
    };
    UserSuggest.prototype.render = function () {
        var props = this.props;
        return (React.createElement(combobox_1.ObjectSuggest, { objects: props.objects, defaultOptionText: props.defaultOptionText, onChange: props.onChange, onBlur: props.onBlur, selected: props.selected, autofocus: props.autofocus, objectToSuggestion: this.objectToSuggestion, focusInputOnSuggestionClick: props.focusInputOnSuggestionClick, id: props.id }));
    };
    UserSuggest = __decorate([
        mobx_react_1.observer
    ], UserSuggest);
    return UserSuggest;
}(React.Component));
exports.UserSuggest = UserSuggest;
